<div class="wrapper selenium-filter-by-grade">
    <ng-select
        [@fadeInXY]="ngSelect.isOpen"
        #ngSelect
        dropdownPosition="bottom"
        placeholder="Grade"
        [items]="options"
        [multiple]="true"
        [closeOnSelect]="false"
        [searchable]="false"
        (change)="changeGrade()"
        (remove)="removeLastGrade($event)"
        [(ngModel)]="selectedGrades"
        class="dropdown"
    >
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items ? items.slice(0, 2) : []">
                <span class="ng-value-label">{{ item }}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
                <span class="ng-value-label">+{{ items.length - 2 }} more</span>
            </div>
        </ng-template>
    </ng-select>
</div>
